import { useEffect, useState } from "react";

const LOCAL_STORAGE_KEY = "recentlySearchedPatients";

const getRecentPatientsFromLocalStroage = () => {
  const locallyStoredPatientsString = localStorage.getItem(LOCAL_STORAGE_KEY);
  return locallyStoredPatientsString
    ? JSON.parse(locallyStoredPatientsString)
    : [];
};

const updateRecentPatientsInLocalStorage = (recentPatientIds: number[]) => {
  if (recentPatientIds.length !== 0) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(recentPatientIds));
  }
};

const useRecentlySearchedPatients = () => {
  const [recentPatientIds, setRecentPatientIds] = useState(
    getRecentPatientsFromLocalStroage()
  );

  const addPatientToRecent = (patientID: number) => {
    if (recentPatientIds.length) {
      if (recentPatientIds.includes(patientID)) {
        const updatedRecentPatientList = [...recentPatientIds];
        updatedRecentPatientList.splice(recentPatientIds.indexOf(patientID), 1);
        setRecentPatientIds([...updatedRecentPatientList, patientID]);
      } else {
        if (recentPatientIds.length < 5) {
          setRecentPatientIds((prevState: number[]) => [
            ...prevState,
            patientID,
          ]);
        } else if (recentPatientIds.length === 5) {
          setRecentPatientIds((prevState: number[]) => [
            ...prevState.slice(1),
            patientID,
          ]);
        }
      }
    } else {
      setRecentPatientIds([patientID]);
    }
  };

  useEffect(() => {
    updateRecentPatientsInLocalStorage(recentPatientIds);
  }, [recentPatientIds]);

  return {
    recentPatientIds,
    addPatientToRecent,
  };
};

export default useRecentlySearchedPatients;
